import React from 'react'
import PropTypes from 'prop-types'
import AlertContainer from 'react-alert'

const alertOptions = {
  offset: 14,
  position: 'top right',
  theme: 'dark',
  time: 5000,
  transition: 'scale'
}

class ListController extends React.PureComponent {
  constructor (props, context) {
    super(props, context)
    this.state = {
      limit: props.limit || 10,
      total: 0,
      pages: [],
      rows: [],
      isLoading: false,
      sortDirection: props.initialSortDirection || 'DESC',
      sortBy: null
    }

    this.bindSortBys(props.sortBys || [])
  }

  componentDidMount () {
    this.onSort(this.props.initialSortBy)
  }

  componentWillReceiveProps (newProps) {
    if (newProps.filters !== this.props.filters ||
      (newProps.match && this.props.match && newProps.match.url !== this.props.match.url) ||
      (newProps.search !== this.props.search) ||
      (newProps.refreshList !== this.props.refreshList)) {
      this.setState({
        limit: newProps.limit || 10,
        total: 0,
        pages: [],
        rows: [],
        isLoading: false
      }, () => {
        const sort = this.sortPairToString(this.state.sortBy, this.state.sortDirection)
        this.loadData({ sort, props: newProps })
      })
    }
  }

  getCurrentPage (props) {
    props = props || this.props
    const pageParam = props.match &&
      props.match.params &&
      props.match.params.paginationPage
    const currentPage = pageParam ? parseInt(pageParam) : 1
    return currentPage
  }

  hasRouting = () => !!(this.props.match && this.props.match.params)

  onSort (sortBy) {
    if (this.props.history) {
      const previousClassName = document.body.className
      setTimeout(() => {
        if (previousClassName && previousClassName.indexOf('modal-open') !== -1) {
          if (!document.body.className || document.body.className === '') {
            document.body.className = 'modal-open'
          } else {
            document.body.className += ' modal-open'
          }
        }
      })
    }
    let sortDirection = this.state.sortDirection
    if (sortBy === this.state.sortBy) {
      sortDirection = sortDirection === 'DESC' ? 'ASC' : 'DESC'
    }
    let sort = this.sortPairToString(sortBy, sortDirection)
    this.setState({sortBy, sortDirection}, () => {
      this.props.onClearRowSelect && this.props.onClearRowSelect()
      this.loadData({sort, page: 1})
    })
  }

  onChangePage = (page) => {
    if (this.props.history) {
      const path = this.props.match.path
      this.props.history.push(path.replace(':paginationPage', page))
    }
  }

  sortPairToString = (sortBy, sortDirection) =>
    sortDirection === 'DESC'
      ? '-' + sortBy
      : sortBy

  loadData = async ({sort, page, props} = {}) => {
    if (process.env.NODE_ENV === 'test') return

    page = page || this.getCurrentPage(props)
    if (this.getCurrentPage(props) !== page) {
      this.onChangePage(page)
    }
    const limit = this.state.limit
    const {filters, fetchList, search} = props || this.props
    const offset = (page - 1) * limit
    this.setState({isLoading: true})

    try {
      const data = await fetchList({ offset, limit, filters, sort, search })

      this.setState({
        ...data,
        isLoading: false
      })
    } catch (error) {
      this.setState({isLoading: false})
      console.info('Error: ' + JSON.stringify(error.data, null, 2))
      if (this.msg) {
        const errorMessage = error.data
          ? error.data.message
          : 'Unable to fetch'
        this.msg.show(errorMessage, {
          time: 4000,
          type: 'error'
        })
      }
    }
  }

  bindSortBys = (sortBys) => {
    this.onSorts = {}
    sortBys.map(key => {
      this.onSorts[key] = this.onSort.bind(this, key)
    })
  }

  onSetRowAttribute = (e, index, attribute, value) => {
    const { rows } = this.state
    const _rows = JSON.parse(JSON.stringify(rows))
    _rows[index][attribute] = value
    this.setState({rows: _rows})
  }

  render () {
    const methods = {
      onSetRowAttribute: this.onSetRowAttribute,
      onSorts: this.onSorts
    }

    const DisplayComponent = this.props.displayComponent

    // paginaiton, filter, sort
    return <div>
      <DisplayComponent
        {...methods}
        {...this.props}
        {...this.state} />
      <AlertContainer ref={a => (this.msg = a)} {...alertOptions} />
    </div>
  }
}

ListController.propTypes = {
  limit: PropTypes.number,
  sortBys: PropTypes.array,
  initialSortBy: PropTypes.string,
  initialSortDirection: PropTypes.string,
  displayComponent: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node
  ]).isRequired,
  match: PropTypes.object,
  history: PropTypes.object,
  filters: PropTypes.object,
  search: PropTypes.string,
  refreshList: PropTypes.number,
  onClearRowSelect: PropTypes.func
}

export default ListController



// WEBPACK FOOTER //
// ./src/components/ListController/ListController.js